var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.929,
    height: 13,
    viewBox: "0 0 13.929 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-reply",
    "data-name": "Icon awesome-reply",
    d: "M.226,5.83,5.014,1.42a.65.65,0,0,1,1.08.527V4.27c4.37.053,7.835.988,7.835,5.4a6.045,6.045,0,0,1-2.267,4.473.491.491,0,0,1-.764-.541c1.234-4.208-.585-5.325-4.8-5.39v2.551a.65.65,0,0,1-1.08.527L.226,6.884a.728.728,0,0,1,0-1.054Z",
    transform: "translate(0 -1.25)",
    fill: "#025376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.a85319d80f3b05a4746a01b895b4d4ae.svg";
export { ForwardRef as ReactComponent };